import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Blog = () => {
  return (
    <div>
      <Container className="text-justify">
        <Row className="mt-5">
          <h2 className="text-center">Welcome to blog</h2>
          <br />
          <br />
          <hr className="text-success opacity-75" />
        </Row>
        <Row>
          <Col className="my-3">
            <h3>1. Difference between javascript and nodejs</h3>
            <p className="mb-3">
              <span className="h5">JavaScript</span> is a popular language which
              runs inside website browsers as part of documents loaded by that
              browser. It gives behaviour to the web pages (CSS gives form or
              look &amp; feel and HTML gives semantic structure). We can say
              that JS helps in providing advanced web development solutions.
              However, nothing should restrict JS to run solely inside any web
              browser.
            </p>
            <p>
              The <span className="h5">Node</span> Or {" "}
              <span className="h5">Node.js</span> usually represents a set of
              methods and objects found in JavaScript code when working with V8
              or with a node translator. This is the working time of the JS
              library. Additionally, if you know about Java it means that Java
              goes from JRE to JVM in the same way JavaScript is a Node to V8.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="my-3">
            <h3>
              2. When should you use nodejs and when should you use mongodb?
            </h3>
            <p className="mb-3">
              MongoDB is a NoSQL DBMS, usually people prefer mongoDB for
              following reasons:
            </p>
            <ol>
              <li>
                NoSQL Database Management Systems are more flexible than RDBMS
              </li>
              <li>
                The expense of maintaining and even setting up a RDBMS is
                relatively high
              </li>
              <li>
                MongoDB is an open source database management system (DBMS)
                <br></br> that uses a document-oriented database model which
                supports various forms of data
              </li>
              <li>It holds a set of collections and stores data as document</li>
              <li>Can handle variety of data and huge amount of data</li>
            </ol>
          </Col>
        </Row>
        <Row>
          <Col className="my-3">
            <h3>3. What is the purpose of jwt and how does it work?</h3>
            <p className="mb-3">
              A <span className="h5"> JWT</span> is a mechanism to verify the
              owner of some JSON data. It’s an encoded, URL-safe string that can
              contain an unlimited amount of data (unlike a cookie) and is
              cryptographically signed.
            </p>
            <div className="ps-2">
              <h5 className="ps-2">Purpose of jwt</h5>
              <p>
                JWT will verify the signature to ensure that the token hasn’t
                been altered after it was signed by the issuer. It is difficult
                for unauthenticated sources to guess the signing key and attempt
                to change the claims within the JW
              </p>
            </div>
            <div className="ps-2">
              <h5 className="ps-2">How JWT work</h5>
              <ul>
                <li>
                  The signature of a JWT can only be produced by someone in
                  possession of both the payload (plus the header) and a given
                  secret key.
                </li>
                <li>
                  A JWT is a string made up of three parts, separated by dots
                  (.), and serialized using base64.
                </li>
                <li>
                  Once decoded, you will get two JSON strings: <br />
                  <strong> 1.</strong> The header and the payload. <br />
                  <strong> 2.</strong> The signature
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Blog;
